export default __webpack_public_path__ + "static/thick-2ad041aa78c52c751198d1ebfa13da7c.png";